var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_14413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.59984 3.09935C7.05872 2.99193 7.52855 2.93824 7.99984 2.93935C12.6665 2.93935 15.3332 8.27268 15.3332 8.27268C14.9285 9.02975 14.4459 9.7425 13.8932 10.3993M9.41317 9.68601C9.23007 9.88251 9.00927 10.0401 8.76394 10.1494C8.51861 10.2587 8.25377 10.3175 7.98523 10.3223C7.71669 10.327 7.44995 10.2776 7.20091 10.177C6.95188 10.0764 6.72565 9.9267 6.53573 9.73678C6.34582 9.54687 6.1961 9.32064 6.09551 9.07161C5.99492 8.82257 5.94552 8.55583 5.95026 8.28729C5.955 8.01875 6.01378 7.75391 6.12309 7.50858C6.2324 7.26325 6.39001 7.04245 6.5865 6.85935M11.9598 12.2327C10.8202 13.1013 9.43258 13.5826 7.99984 13.606C3.33317 13.606 0.666504 8.27268 0.666504 8.27268C1.49576 6.72728 2.64593 5.37709 4.03984 4.31268L11.9598 12.2327Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 0.939331L15.3332 15.606",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_14413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.272705)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.3aa1c4268c79caf7f5e7a6979954dec0.svg";
export { ForwardRef as ReactComponent };